export interface Gear {
  i: number;
  n: number;
}
